import axios from "axios";

export default {
    namespaced: true,
    state: {
        assemblelist:[],
        assemble_info:{}
    },
    getters:{
        assemblelist(state){
            return state.assemblelist
        },
        assemble_info(state){
            return state.assemble_info
        }
    },  
    mutations:{
        SET_ASSEMBLE_LIST (state, payload) {
            state.assemblelist = payload
        },
        SET_ASSEMBLE_INFO(state, payload) {
            state.assemble_info = payload
        }
    },
    actions:{
       async getAssembleList(context,param){
        const response = await axios.get('/api/assembleRequest',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){
                context.commit('SET_ASSEMBLE_LIST',response.data.data)
            }
       },
       async getAssembleInfo(context,param){
            context.commit('SET_ASSEMBLE_INFO',param)
       }
    }
}